<template>
  <Form class="col-span-full mx-auto gravity-theme register max-w-[732px] bg-white p-4 min-[680px]:p-14 rounded-[15px] border border-solid border-[#E9E9E9] bg-white" @submit="onSubmit" :validation-schema="schema" v-slot="{ meta }">
    <h1 class="text-t2 mb-4" v-if="registerDone">Bekräfta din e-postadress</h1>
    <h1 class="text-t2 mb-4" v-else-if="sparDone">Kontaktuppgiter</h1>
    <h1 class="text-t2 mb-4" v-else>Registrera dig</h1>

    <div v-if="!showPolicy">

      <div class="register__preamble" v-if="!registerDone">
        <div class="link-basic" v-html="webapp_config.msg.registration_info"></div>
        <div class="flex mt-4 pr-[11px] items-center gap-2 rounded-[6px] bg-[#E6F4F8] p-2"><IconBankIDLarge class="min-w-[55px]"/><div><span class="py-[11px]">Se till att ha BankID redo för att identifiera dig i sista steget</span><br /><a :href="webapp_config.msg.registration_link" class="text-b4 sm:inline md:flex items-center">Har du inget BankID? Registrera dig här istället <IconArrowRightReg class="inline sm:ml-1 md:ml-2" /></a></div></div>
      </div>

      <StepWizard :active-step="currentStep" />

      <div class="grid grid-cols-1" v-if="!registerDone">
        <div class="col-span-1" v-if="!sparDone">
          <label class="text-b2 font-bold" for="inputAge">Personnummer - ÅÅÅÅMMDDNNNN *</label>
          <p class="flex flex-col items-start relative" :class="{ control: true }">
            <Field
              v-slot="{ field, meta }"
              v-model="applicant.civicNumber"
              name="id"
              type="text"
              id="inputAge"
              label="Personnummer"
            >
              <input
                v-bind="field"
                :data-valid="meta.valid && isOldEnough() ? 'true' : 'false'"
                placeholder="ÅÅÅÅMMDDNNNN"
                :disabled="sparDone"
                @input="event => checkText(event.target.value, meta.valid)"
              />
              <span class="check"></span>
              <span class="text-date text-[13px]">Vi använder <a href="https://www.statenspersonadressregister.se/master/start/om-spar/" class="link-basic">SPAR</a> för att hämta dina uppgifter.</span>
              <ErrorMessage name="id" />

              <div class="formerror mt-2" v-if="errorDescription">{{errorDescription}}</div>

              <a :href="webapp_config.msg.registration_link" class="text-b4 sm:inline md:flex items-center mt-3">Har du samordningsnummer? Registrera dig här istället <IconArrowRightReg class="inline sm:ml-1 md:ml-2" /></a>

              <div class="flex w-full justify-end mt-4" v-if="!sparDone">
                <Button @click="fetchSpar()" :loading="isFetching" loadingText="Hämtar uppgifter" variant="primary" size="extralarge" :disabled="!meta.valid || !isOldEnough() || (errorDescription && errorDescription.length>0)">
                  Fortsätt
                </Button>
              </div>
            </Field>
          </p>
        </div>
      </div>



      <div v-if="sparDone && !registerDone">

        <div class="grid grid-cols-1 gap-x-[16px] gap-y-[8px]">
          <h2 class="text-t5">Dina uppgifter</h2>
          <h3 class="text-b2 font-bold mt-4">Namn och adress</h3>
          <p class="size-full">{{applicant.firstName}} {{applicant.lastName}}</p>
          <p class="size-full" v-if="applicant.careOf">C/o {{applicant.careOf}}</p>

          <p class="size-full">{{applicant.address}}</p>
          <p class="size-full" v-if="applicant.address2">{{applicant.address2}}</p>
          <p class="size-full">{{applicant.zipCode}} {{applicant.city}}</p>


          <div class="col-span-1 mt-6">
              <label class="text-b2 font-bold" for="inputPhoneMobile">Telefonnummer *</label>
              <div :class="{ control: true }">
                <div>
                  <Field
                    v-slot="{ field, meta }"
                    v-model="applicant.phoneMobile"
                    name="phoneMobile"
                    id="inputPhoneMobile"
                    type="text"
                    @keyup.delete="isDefaultNumber($event)"
                    autocomplete="off"
                    label="Telefonnumret"
                    :rules="validatePhone"
                  >
                    <input
                      v-bind="field"
                      :data-invalid="!meta.valid && meta.touched ? 'true' : 'false'"
                      placeholder="ex. 0701234567"
                    />
                  </Field>
                                  </div>
                <ErrorMessage name="phoneMobile" />
              </div>
            </div>
            <div :class="showHome ? 'self-end' : 'self-center'">

              <button class="addPhone block text-b4 text-[#007893] mt-[-6px]" v-if="!showHome" @click="showHome = !showHome">
                {{ showHome ? 'Dölj extra telefonnummer' : 'Lägg till telefonnummer' }}
              </button>


              <div class="col-span-1" v-if="!!showHome">
                <label for="inputPhoneHome" class="text-b2 font-bold">Telefonnummer</label>
                <div :class="{ control: true }">
                  <div>
                    <Field
                      v-slot="{ field, meta }"
                      v-model="applicant.phoneHome"
                      name="phoneHome"
                      id="inputPhoneHome"
                      type="text"
                      autocomplete="off"
                      label="Telefonnumret"
                    >
                      <input
                        v-bind="field"
                        :data-invalid="!meta.valid && meta.touched ? 'true' : 'false'"
                        placeholder="ex. 0701234567"
                      />
                    </Field>
                  </div>
                  <ErrorMessage name="phoneHome" />
                </div>
              </div>
            </div>
          </div>

          <div class="col-span-1 mt-4 md:mt-6">
            <label for="inputEmail" class="text-b2 font-bold">E-postadress *</label>
            <Field
              v-slot="{ field, meta }"
              v-model="applicant.email"
              name="email"
              id="inputEmail"
              type="text"
              autocomplete="off"
              label="E-postadressen"
            >
              <input
                v-bind="field"
                :data-invalid="((!meta.valid && meta.touched) || (meta.touched && duplicateEmail) || (meta.touched && isInvalid)) ? 'true' : 'false'"
                placeholder="ex. namn.efternamn@epost.se"
              />
            </Field>
            <ErrorMessage name="email" />
          </div>

        <div class="col-span-1 mt-4 md:mt-6">
          <label for="inputEmailValidate" class="text-b2 font-bold">Bekräfta din e-postadress *</label>
          <Field
            v-slot="{ field, meta }"
            v-model="applicant.emailValidate"
            name="emailValidate"
            id="inputEmailValidate"
            type="text"
            autocomplete="off"
            label="E-postadress"
          >
            <input
              v-bind="field"
              :data-valid="meta.touched && !duplicateEmail && meta.valid ? 'true' : 'false'"
              :data-invalid="((!meta.valid && meta.touched) || (meta.touched && duplicateEmail)) ? 'true' : 'false'"
              placeholder="ex. namn.efternamn@epost.se"
            />
          </Field>
          <ErrorMessage name="emailValidate" />
        </div>


        <div class="register__policy mt-6">
          <div class="register__policy__content">
            <h2 class="text-t5 mb-2">Personuppgiftspolicy</h2>
            <div class="link-basic" v-html="webapp_config.msg.policy_msg"></div>

            <div class="flex mt-2 items-center">
              <Checkbox id="confirm" label="Jag samtycker" name="confirm" v-model="checkedPolicy" />
            </div>
          </div>
          <div v-if="formErrorMsg" class="formerror">
            {{ formErrorMsg }}
          </div>

          <!-- Debug-panel -->


          <Field name="id" v-slot="{ meta }" class="hidden">
          </Field>



          <div class="flex justify-between">
            <Button v-if="!!sparDone" @click="currentStep = 1; applicant = []; sparDone=false" variant="secondarywhite" size="large">
              Tillbaka
            </Button>
            <Button type="submit" @click="onSubmit" variant="primary" :disabled="!meta.valid || !checkedPolicy" size="large" :loading="isRegistring" loadingText="Fortsätt">
              Fortsätt
            </Button>
          </div>
        </div>
      </div>

      <div v-if="registerDone">
        <div class="register__preamble">
          <p class="text-b1">Vi har skickat ett e-postmeddelande till <span class="font-bold underline">{{applicant.email ?? 'din e-post' }}</span> med en länk där du bekräftar din e&#8209;postadress och fortsätter din registrering.</p>
        </div>
        <div>
          <h2 class="text-t6 mb-2">Har du inte fått ett e-postmeddelande?</h2>
          <p>Kontrollera att den e-postadress du angett är korrekt, att vårt e-postmeddelande inte hamnat i din skräppostmapp eller att din inkorg är full. Om så inte är fallet är du varmt välkommen att kontakta oss.</p>
        </div>
      </div>

    </div>
  </Form>
</template>

<script setup>
const schema = {
  email: 'required|email',
  emailValidate: 'required|email|confirmed:email',
  id: 'required|swedishSSN|swedishSSNWrong|min:12|max:12',
  phoneMobile: 'required|numeric|min:7|max:10',
  phoneHome: 'numeric|max:10'
};

</script>

<script>
import { mapGetters } from 'vuex';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Modal from '@/components/ui/modal';
import StepWizard from '@/components/ui/StepWizard';
import Loader from '@/components/ui/loader';
import dayjs from 'dayjs';
import { PREFERED_CONTACT_METHOD_VALUES } from '@/config/constants';
import { dataLayerPush } from '@/helpers/datalayer';
import IconBankIDLarge from '@/components/icons/IconBankIDLarge';
import Button from '@/components/ui/button';
import Checkbox from '@/components/ui/form/checkbox';
import IconArrowRightReg from '@/components/icons/IconArrowRightReg'

export default {
  name: 'register',
  components: { Modal, Loader, Button, Form, Field, ErrorMessage, StepWizard, IconBankIDLarge, Checkbox, IconArrowRightReg },
  data() {
    return {
      formErrorMsg: false,
      showHome: false,
      showLoader: false,
      showPolicy: false,
      checkedPolicy: false,
      fetchZipInfo: '',
      sparDone: false,
      registerDone: false,
      errorDescription: null,
      isFetching: false,
      currentStep: 1,
      duplicateEmail: false,
      isInvalid: false,
      isRegistring: false,
      applicant: {
        civicNumber: null,
        firstName: '',
        lastName: '',
        email: null,
        postalAddress: '',
        postalAddress2: '',
        zipCode: '',
        city: '',
        phoneMobile: '',
        phoneHome: '',
        inputEmailValidate: null,
        preferredContactMethod: PREFERED_CONTACT_METHOD_VALUES.EMAIL,
        defaultPhone: 'phoneMobile',
      },
    };
  },
  computed: {
    ...mapGetters({
      currentDate: 'currentDate',
      webapp_config: 'webapp_config',
    }),
  },

  mounted() {
    //$('#gdpr-policy').focus();
  },

  methods: {
    checkText(val, valid) {

      if (!val || val.length > 1){
        if(this.isOldEnough()) {
          this.errorDescription = null;
          this.formErrorMsg = null;
        }
        else {
          if(val.length == 12) {
            this.errorDescription = this.formErrorMsg;
          }
        }
      } else if(val.length < 12) {
        this.errorDescription = null;
        this.formErrorMsg = null;
      }
    },

    fetchSpar() {
      this.duplicateEmail = false;

      if(!this.isOldEnough()){
        this.errorDescription = "För att du ska kunna registrera dig i kön ska du ha fyllt 16 år. Välkommen tillbaka! ";
        return false;
      }

      this.isFetching = true;
      this.errorDescription = null;


      this.$store.dispatch('fetchSpar', this.applicant.civicNumber)
        .then((data) => {
          if(data.firstName != null) {
            let temp = this.applicant.civicNumber;
            this.sparDone = true;
            this.applicant = data;
            this.isFetching = false;
            this.currentStep = 2;
            this.applicant.civicNumber = temp;
          }
          else {
            this.errorDescription = "Det gick inte att hämta dina uppgifter. Vänligen kontakta kundtjänst på 026-17 27 00 så hjälper vi dig med din registrering.";
            this.isFetching = false;
          }
        })
        .catch((error) => {
          if (error.status === 409) {
            this.errorDescription = "Det gick inte att hämta dina uppgifter. Vänligen kontakta kundtjänst på 026-17 27 00 så hjälper vi dig med din registrering.";
          } else {
            this.errorDescription = "Det gick inte att hämta dina uppgifter. Vänligen kontakta kundtjänst på 026-17 27 00 så hjälper vi dig med din registrering.";
          }
          this.isFetching = false;

          console.error('Fel vid hämtning av personuppgifter:', error);
      })
    },

    validatePhone(value) {
      if (
        this.applicant.phoneMobile !== '' ||
        this.applicant.phoneHome !== ''
      ) {
        return true;
      } else {
        return false;
      }
    },

    isOldEnough() {
      var birthday = this.applicant.civicNumber;
      var isNumbers = /^\d+$/.test(birthday);
      if (!birthday || birthday.length>12 || birthday.length<11 || !isNumbers) return false;

      // Personnumrets 4 sista siffror är löpnummer/kontrollsiffra, inte en del av datumet.
      // Plockar ut enbart ÅÅÅÅMMDD så de inte råkar tolkas som klockslag.
      var datePart = birthday.substring(0, 8);
      var year = parseInt(datePart.substring(0, 4), 10);
      var month = parseInt(datePart.substring(4, 6), 10);
      var day = parseInt(datePart.substring(6, 8), 10);

      var years = dayjs().diff(dayjs(new Date(year, month - 1, day)), 'years');



      if (years >= 16) {
        this.formErrorMsg = false;
        return true;
      } else {
        this.formErrorMsg = 'Du behöver vara minst 16 år för att ställa dig i kö.';
        return false;
      }
    },

    isDefaultNumber(el) {
      if (el.target.value === '' && el.target.name == this.applicant.defaultPhone) {
        if (this.applicant.phoneMobile !== '') {
          this.applicant.defaultPhone = 'phoneMobile';
        } else if (this.applicant.phoneHome !== '') {
          this.applicant.defaultPhone = 'phoneHome';
        } else this.applicant.defaultPhone = 'phoneMobile';
      }
    },

    goToPolicy() {
      dataLayerPush({ event: 'click-button-step-1-ga-vidare' });

      //   this.$validator.validateAll().then(result => {

      if (result) {
        if (this.isOldEnough()) {
          this.showPolicy = true;
          window.scroll(0, 0);
        }
        else {

        }
        return;
      }

      // });
    },

    back() {
      // Ändrar routen för att ev felmeddelandet ska försvinna
      this.$router.push({ query: { r: Math.random() } });

      this.showPolicy = false;
    },

    onSubmit(event) {
      if (!this.applicant.phoneMobile || (this.applicant.phoneMobile.length < 7 ) || (this.applicant.phoneMobile.length > 10)) {
        this.formErrorMsg = 'Du måste ange ett giltigt telefonnummer';
        return;
      }

      this.registerUser();
    },

    registerUser(event) {
      this.formErrorMsg = '';
      if (event) {
        event.preventDefault(); // Prevents the form from submitting
      }
      if (this.isOldEnough()) {
        if (!this.showLoader) {
          dataLayerPush({ event: 'click-button-step-2-ga-vidare' });
          this.formErrorMsg = false;
          this.showLoader = true;

          let registerObject = { ...this.applicant };
          registerObject.defaultPhone = "phoneMobile";
          delete registerObject.city;
          delete registerObject.zipCode;
          delete registerObject.address;
          delete registerObject.careOf;
          delete registerObject.firstName;
          delete registerObject.lastName;
          delete registerObject.emailValidate;


          this.isRegistring = true;

          return this.$store
            .dispatch('createProfile', registerObject)
            .then((result) => {
              //this.$router.replace(this.$route.query.redirect || '/information');
              window.scrollTo(0,0);
              this.registerDone = true;
              this.currentStep = 3;
            })
            .catch((err) => {
              this.isRegistring = false;
              if (err.errors[0].description == "Civic number already exists")
                this.formErrorMsg = 'Det gick inte att hämta dina uppgifter. Vänligen kontakta kundtjänst på 026-17 27 00 så hjälper vi dig med din registrering.';
              else if (err.errors[0].description == "Email already exists") {
                this.duplicateEmail = true;
                this.formErrorMsg = 'En användare med denna e-post finns redan registrerad';
              }
              else if (err.errors[0].data[0].description.indexOf(" redan taget") > -1) {
                this.duplicateEmail = true;
                this.formErrorMsg = 'En användare med denna e-post finns redan registrerad';
              }
              else this.formErrorMsg = 'Det gick inte att hämta dina uppgifter just nu. Försök igen eller kontakta kundtjänst på 026-17 27 00 så hjälper vi dig med din registrering';
            })
            .finally((err) => {
              this.isRegistring = false;
              this.showLoader = false;
            });
        }
      } else {
        if (!this.applicant.civicNumber) {
          this.formErrorMsg = 'Du måste ange ett personnummer';
          return;
        }
        this.formErrorMsg = 'Du är för ung för att registrera ett konto hos oss';
      }
    }
  },
};
</script>


<style lang="scss">

.register {

  .register__preamble {

    ul {
      margin-top: 1.6rem;
    }

    li {
      font-size: 1.6rem;
      margin-bottom: 10px;
      position: relative;
      line-height: 1.5;
      margin-left: 28px;
      margin-top: 10px;
    }

    li:before {
      content: "";
      position: absolute ;
      display: inline-block;
      left: -28px;
      top: 6px;
      background-color: unset;
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-left: 8px solid #007893;
      margin-right: 28px;
    }
  }

  .formerror {
    margin-bottom: 16px;
    position: relative;
    display: flex;
    width: 100%;
    padding: 10px 10px 10px 16px;
    align-items: flex-start;
    gap: 10px;
    border-radius: 4px;
    background-color: #FBEBEB;
    overflow: hidden;
    font-size: 1.6rem;
    line-height: 1.4;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 6px;
      height: 100%;
      background-color: #D32F2F;
    }
  }

  .addPhone {
    position: relative;

    &:after {
      position: absolute;
      right: -28px;
      width: 24px;
      height: 24px;
      top: 0;
      content: url(https://tstabgmypagescode.blob.core.windows.net/test-exit-xpand/drop/static/images/plus.svg);
    }

  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .register {
    &__preamble {
      margin-bottom: 32px;
    }

    &__policy {
      &__content {
        border-radius: 6px;
        padding: 14px 16px;
        margin-top: 24px;
        background: #fff6cc !important;
        margin-bottom: 2.4rem;

        .checkedPolicy {
          margin-top: 1rem;
        }

        & p:not(:last-child) {
          margin-bottom: 1rem;
        }
      }
    }

    input {
      width: 100%;
      margin-top: 7px;
      margin-bottom: 8px;
      padding: 7.5px 10px;
      background: #fff;
      border: 1px solid #f0f0f0;
      font-size: 1.4rem;
      line-height: 1.6;
      outline: none;
      transition: box-shadow .15s linear;

      &::placeholder {
        color: #757575;
      }

      &:not(:focus).is-danger {
        border-color: #D32F2F !important;
      }

      &:disabled {
        background-color: $lightgray;
      }

      &[data-invalid="true"] {
        border: 1px solid #D32F2F!important;
      }

      &[data-valid="true"] + span {

        &:after {
          position: absolute;
          right: 16px;
          top: 24px;
          content: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-check.svg);
        }
      }

      &[type="radio"] {
        width: fit-content;
        display: block !important;
        accent-color: #007893;
        margin-right: 8px;

        &:checked+label {
          background: transparent !important;
        }
      }

    }

    [role="alert"] {
      font-family: "proxima-nova", sans-serif;
      color: #212121!important;
      background-color: #FBEBEB;
      border: 1px solid #D32F2F;
      padding: 12px 16px;
      margin-top: 8px;
      display: block;
      border-radius: 2px;
      font-size: 1.3rem!important;
    }

  }


</style>
